module.exports = __webpack_public_path__ + "img/home.ad8bcd11.svg";